import { TwitterIcon, WhatsappIcon, InstagramIcon, FacebookIcon, YoutubeIcon, PintrestIcon } from '@/components/icons/footer-icon';

// ------- 1 -> Footer Social Icons Data ------- //
export const IconsContent = [
    // {
    //     href: '',
    //     icon: <TwitterIcon />,
    // },
    {
        name: 'Whatsapp',
        href: 'https://wa.me/918141261261',
        icon: <WhatsappIcon />,
    },
    {
        name: 'Instagram',
        href: 'https://www.instagram.com/the_kalindi_label',
        icon: <InstagramIcon />,
    },
    {
        name: 'Facebook',
        href: 'https://www.facebook.com/kalindiindia',
        icon: <FacebookIcon />,
    },
    // {
    //     href: '',
    //     icon: <YoutubeIcon />,
    // },
    // {
    //     href: '',
    //     icon: <PintrestIcon />,
    // },
]

// ------- 2 -> Footer List Items Data ------- //
export const footerAccountItems = [
    // {
    //     title: 'Dashboard',
    //     href: '/',
    // },
    {
        title: 'My Account',
        href: '/login',
    },
    {
        title: 'My Orders',
        href: '/login',
    },
    {
        title: 'My Whishlist',
        href: '/login',
    },
    // {
    //     title: 'Track Order',
    //     href: '',
    // },
]

export const footerShopItems = [
    // {
    //     title: 'Discount Products',
    //     href: '',
    // },
    {
        title: 'Latest Products',
        href: '/latest-arrival-products',
    },
    {
        title: 'Bestsellers',
        href: '/best-seller-products',
    },
    {
        title: 'Popular Products',
        href: '/popular-products',
    },
]

// export const footerCategoriesItems = [
//     {
//         title: 'Saree',
//         href: '',
//     },
//     {
//         title: 'Kurti',
//         href: '',
//     },
//     {
//         title: 'Tunic',
//         href: '',
//     },
//     {
//         title: 'Dress',
//         href: '',
//     },
//     {
//         title: 'Plazo',
//         href: '',
//     },
// ]
